import { getApiUrl } from "./config";

export const uploadService = {
   uploadImage: async (file) => {
      const formData = new FormData();
      formData.append("image", file);

      const response = await fetch(getApiUrl("/api/upload"), {
         method: "POST",
         body: formData,
      });

      if (!response.ok) throw new Error("Image upload failed");
      return response.json();
   },
};
